import React, { useState, useEffect } from 'react';
import { MapPin, Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export default function GuideSiteSelectPage() {
    const navigate = useNavigate();
    const [sites, setSites] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadSites = async () => {
            try {
                const user = JSON.parse(localStorage.getItem('guide_user') || '{}');
                const guideSites = user.guide_sites || [];
                if (guideSites.length === 0) {
                    toast.error("Aucun site Guide n'est assigne a votre compte");
                    setLoading(false);
                    return;
                }
                const token = localStorage.getItem('guide_token') || localStorage.getItem('token');
                const res = await fetch(`${API}/api/sites`, {
                    headers: token ? { 'Authorization': `Bearer ${token}` } : {},
                });
                const allSites = await res.json();
                const filtered = allSites.filter(s => guideSites.includes(s.id));
                setSites(filtered);
                if (filtered.length === 1) {
                    localStorage.setItem('guide_selected_site', JSON.stringify(filtered[0]));
                    navigate('/guide', { replace: true });
                }
            } catch { toast.error('Erreur de chargement des sites'); }
            finally { setLoading(false); }
        };
        loadSites();
    }, [navigate]);

    const selectSite = (site) => {
        localStorage.setItem('guide_selected_site', JSON.stringify(site));
        navigate('/guide', { replace: true });
    };

    if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;

    return (
        <div className="px-4 py-8" data-testid="guide-site-select">
            <div className="text-center mb-6">
                <MapPin className="w-8 h-8 text-red-500 mx-auto mb-2" />
                <h1 className="text-xl font-bold text-slate-900">Selectionnez votre site</h1>
                <p className="text-sm text-slate-500 mt-1">Sur quel site etes-vous aujourd'hui ?</p>
            </div>

            {sites.length === 0 ? (
                <div className="text-center py-8 text-slate-400 text-sm">
                    Aucun site ne vous est attribue.<br />Contactez votre administrateur.
                </div>
            ) : (
                <div className="space-y-2">
                    {sites.map(site => (
                        <button
                            key={site.id}
                            onClick={() => selectSite(site)}
                            className="w-full bg-white rounded-xl border border-slate-200 shadow-sm p-4 flex items-center gap-3 active:bg-slate-50 transition-colors text-left"
                            data-testid={`site-option-${site.id}`}
                        >
                            <div className="w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center flex-shrink-0">
                                <MapPin className="w-5 h-5 text-red-500" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="font-semibold text-slate-900 text-sm">{site.name}</p>
                                {site.address && <p className="text-xs text-slate-500 truncate mt-0.5">{site.address}</p>}
                            </div>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
